import { render, staticRenderFns } from "./CoozzyEllipsisIcon.vue?vue&type=template&id=35a84b7e&scoped=true"
import script from "./CoozzyEllipsisIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyEllipsisIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyEllipsisIcon.vue?vue&type=style&index=0&id=35a84b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a84b7e",
  null
  
)

export default component.exports